.footer {
  background: var(--color-primary);
  color: var(--color-text-on-primary);
  min-height: 12rem;
  padding: 1rem;
}

.content {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin: 40px auto;
}

.quote {
  max-width: 60%;
}

.menu {
  background: var(--color-primary);
  font-size: 1.5rem;
  text-align: left;
  width: 140px;
}

.menu span {
  display: none;
}

.list {
  margin-bottom: 2rem;
}

.link {
  color: var(--color-text-on-primary);
}

.logoLink {
  padding: 0;
}

@media (max-width: 767px) {
  .content {
    align-items: flex-start;
    flex-direction: column;
    gap: 2rem;
  }

  .quote,
  .menu {
    max-width: 100%;
    width: 100%;
  }
}
